import layout from '../layout'
export default function makeSeriesCategoriesRoutes({
  contentType,
  components: { SeriesCategoriesListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: SeriesCategoriesListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
